export const alloysPartnersShopifyIntegrationIdFetchCustomerMetafields =
  "/alloys/partners/shopify/:integration_id/fetch_customer_metafields";
